import React from 'react';
import { debounce } from 'lodash';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';

const debouncedUpdate = debounce((updatedValueString, updatedValue, onChange) => onChange(updatedValueString, updatedValue), 200);

const DebouncedTextField = React.forwardRef(({ onChange, value, ...others }, ref) => {
    const [displayedValue, setDisplayedValue] = useState(value ?? "");
    const onValueChange = (ev, changedValue) => {
        debouncedUpdate(ev, changedValue, onChange);
        setDisplayedValue(ev.target.value ?? "");
    };

    useEffect(() => setDisplayedValue(value), [value]);
    return (
        <TextField
            ref={ref}
            onChange={onValueChange}
            value={displayedValue}
            {...others}
        />
    );
});

export default DebouncedTextField;
